module.exports = __webpack_public_path__ + "static/img/loading1.2847961.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/loading1.gif
// module id = xe9v
// module chunks = 1